import CommentPopup from 'components/CommentPopup';
import Footer from 'components/Footer';
import MaxWidthContainer from 'components/MaxWidthContainer';
import Menubar from 'components/Menubar';
import MobileTabBar from 'components/MobileTabBar';
import _ from 'lodash';
import { NextSeo } from 'next-seo';
import { useRouter } from 'next/router';
import qs from 'qs';
import React from 'react';

import api from 'utils/api';

import { useAppLaunch } from 'contexts/AppLaunch';

const { useEffect, useState } = React;

export default function Ranking(props) {
  const { seo } = props;

  const router = useRouter();
  const { query } = router;
  // console.log({ query });
  const { notifications, categoryTree, firstCategoryMap } = useAppLaunch();
  const [firstCategoryId, setFirstCategoryID] = useState(null);

  useEffect(() => {
    if (categoryTree.length > 0) {
      if (!_.isEmpty(query.tab)) {
        const targetCategory = categoryTree.find((category) => {
          return _.toLower(query.tab) === _.toLower(category.alias);
        });
        if (targetCategory) {
          console.log('set firstCategoryID', targetCategory.id);
          setFirstCategoryID(targetCategory.id);
          return;
        }
      }
      setFirstCategoryID(categoryTree[0].id);
    }
  }, [categoryTree, query]);

  const [isCommentModalShow, setIsCommentModalShow] = useState(false);

  return (
    <div>
      <NextSeo title={seo.title} description={seo.description} />
      <main>
        <Menubar
          props={{
            homeExtend: false,
            sourceUI: 'Ranking',
          }}
        />
        <div
          className={
            'globals-centerContentsMargin ranking-banner relative' +
            (notifications.length > 0 ? ' withNoti' : '')
          }
          style={{ backgroundImage: 'url(/images/bg-ranking.png)' }}
        >
          <div className="">
            <MaxWidthContainer className="p-4">
              <div className="pt-[32px] text-3xl font-bold text-sorra-gray-900 lg:pt-[64px] lg:text-5xl">
                美妝排行
              </div>
              <div className="hidden pt-[12px] text-lg font-medium text-sorra-gray-900 lg:block">
                Sorra 排行榜集合最新最熱美妝產品，讓你緊貼美妝潮流！
              </div>
              <div className="block pt-[8px] font-medium text-sorra-gray-900 lg:hidden">
                Sorra 排行榜集合最新最熱美妝產品，
                <br />
                讓你緊貼美妝潮流！
              </div>
            </MaxWidthContainer>
          </div>

          <div className="absolute bottom-0 h-[40px] w-full overflow-scroll lg:h-[52px]">
            <MaxWidthContainer className="ranking-category flex h-full gap-x-[24px] px-4 lg:gap-x-[32px]">
              {!_.isNil(firstCategoryId) &&
                categoryTree.map((category) => {
                  const { id, name } = category;
                  return (
                    <div
                      key={id}
                      className="cursor-pointer"
                      onClick={() => {
                        setFirstCategoryID(id);
                      }}
                    >
                      <div
                        className={
                          'h-[24px] lg:h-[30px] lg:text-xl' +
                          (firstCategoryId == id ? ' font-bold' : '')
                        }
                      >
                        {name}
                      </div>
                      <div
                        className={
                          'mt-[12px] h-[3px] lg:mt-[19px]' +
                          (firstCategoryId == id ? ' bg-sorra-pink' : '')
                        }
                      ></div>
                    </div>
                  );
                })}
            </MaxWidthContainer>
          </div>
        </div>

        <div className="pt-[24px] lg:pt-[34px]">
          <MaxWidthContainer className="grid grid-cols-1 gap-x-6 gap-y-[28px] p-4 lg:grid-cols-2">
            {!_.isNil(firstCategoryId) &&
              firstCategoryMap[firstCategoryId] &&
              firstCategoryMap[firstCategoryId].second_categories.map(
                (secondCategory) => {
                  const { id, name, image, rating_updated_at } = secondCategory;
                  const searchQuery = qs.stringify(
                    {
                      category: name,
                      categoryID: id,
                    },
                    { skipNulls: true }
                  );
                  const searchURL = `/search?${searchQuery}`;

                  return (
                    <button
                      key={id}
                      onClick={() => {
                        router.push(searchURL);
                      }}
                      className="flex h-[96px] items-center rounded-lg bg-[#f5f5f580] px-[16px] py-[16px] transition-all hover:bg-[#F5F5F5] lg:h-[224px] lg:px-[32px] lg:py-[32px]"
                    >
                      <img
                        className="aspect-[1/1] h-full"
                        src={
                          image ? image.url : 'images/placeholders/product.png'
                        }
                      ></img>
                      <div className="grow pl-[32px]">
                        <div className="text-xl font-bold text-sorra-gray-900 lg:text-4xl">
                          {name + '組'}
                        </div>
                      </div>
                    </button>
                  );
                }
              )}
          </MaxWidthContainer>
        </div>

        <div className="pt-6 lg:pt-24"></div>

        <CommentPopup
          externalPopupShown={isCommentModalShow}
          externalProductID={null}
          externalProductBrandName={null}
          externalProductName={null}
          setExternalPopupShown={setIsCommentModalShow}
        />

        <Footer />

        <MobileTabBar props={{ highlighted: 'leaderboard' }} />
      </main>
    </div>
  );
}

export async function getServerSideProps(ctx) {
  let title = `香港最真實的化妝品及護膚品推薦排行榜 2025 (持續更新) | Sorra`;
  let description = `Sorra提供香港2025年最新的化妝品及護膚品推薦排行榜，排名基於真實用戶評價，產品覆蓋護膚保養、身體保養、底妝、彩妝、定妝、頭髮保養及月事等多個類別。立即探索美妝及護膚產品的最新排名！ (持續更新)`;

  try {
    const { data } = await api.request({
      method: 'GET',
      url: `/api/seo/rankingPage`,
    });
    if (data) {
      const {
        page_title: pageTitle = '',
        page_meta_description: pageDescription = '',
      } = data;
      if (pageTitle) {
        title = pageTitle;
      }
      if (pageDescription) {
        description = pageDescription;
      }
    }
  } catch (error) {
    // console.error('Error in fetching ranking page SEO data:', error);
  }

  return {
    props: {
      seo: { title, description },
    },
  };
}
